import React from 'react';
import { Provider } from 'react-redux';
import { MemoryRouter, Switch, Route } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
// eslint-disable-next-line no-unused-vars
import setGeotabService from './geotab/geotabService';
import store from './store';
import ProtectedRoute from './security/ProtectedRoute';
import DefaultComponent from './security/DefaultComponent';
import DefaultTheme from './theme/DefaultTheme';
import Library from './library';
import Player from './player';
import OnDemand from './onDemand';
import Security from './security';
import GlobalNotification from './globalNotification/GlobalNotification';
import FirstTimeSetup from './firstTimeSetup';
import ResetPassword from './resetPassword';
import Report from './report';
import DVRhealth from './dvrHealth';
import AdminPage from './admin';
import DvrToolkitPage from './dvrToolkit';
import Dashboard from './dashboard';
import './styles/index.scss';
import './styles/flowplayer/skin/skin.css';

function App() {
  const initialEntries = [
    '/',
    '/admin',
    '/dvrHealth',
    '/fistTimeSetup',
    '/library',
    '/onDemand',
    '/player',
    '/reports',
    '/dashboard',
    '/resetPassword',
    '/dvrToolkit',
  ];
  return (
    <Provider store={store}>
      <DefaultTheme>
        <MemoryRouter initialEntries={initialEntries} initialIndex={0}>
          <Security>
            <Switch>
              <ProtectedRoute exact path="/" component={DefaultComponent} />
              <ProtectedRoute exact path="/library" component={Library} />
              <ProtectedRoute exact path="/player" component={Player} />
              <ProtectedRoute
                exact
                path="/onDemand"
                component={OnDemand}
                roles={[
                  'videoIntelligenceManager',
                  'videoIntelligenceAdmin',
                  'videoIntelligenceInternal',
                ]}
              />
              <ProtectedRoute
                disabledOnMobile
                exact
                path="/reports"
                component={Report}
                roles={[
                  'videoIntelligenceManager',
                  'videoIntelligenceAdmin',
                  'videoIntelligenceInternal',
                ]}
                title={I18n.t('page.reports.title')}
              />
              <ProtectedRoute
                exact
                path="/dvrHealth"
                component={DVRhealth}
                title={I18n.t('page.dvrHealth.title')}
              />
              <ProtectedRoute
                disabledOnMobile
                exact
                path="/admin"
                component={AdminPage}
                roles={['videoIntelligenceAdmin', 'videoIntelligenceInternal']}
                title={I18n.t('page.admin.title')}
              />
              <ProtectedRoute
                roles={['videoIntelligenceAdmin', 'videoIntelligenceInternal']}
                exact
                path="/resetPassword"
                component={ResetPassword}
              />
              <Route exact path="/dashboard" component={Dashboard} />
              <ProtectedRoute
                exact
                path="/dvrToolkit"
                component={DvrToolkitPage}
              />
              <Route exact path="/fistTimeSetup" component={FirstTimeSetup} />
            </Switch>
          </Security>

          <GlobalNotification />
        </MemoryRouter>
      </DefaultTheme>
    </Provider>
  );
}

export default App;
